import { useMutation } from '@tanstack/react-query';
import api from '../../http';
import { toApiError } from '../utils';
import type { SignPlanPayload } from './useSignPlan';

export const useSignUpgradePlan = () =>
	useMutation({
		mutationFn: async ({ planId, payload }: { planId: string; payload: SignPlanPayload }) => {
			try {
				return (await api.post(`/user/plan/sign-upgrade/${planId}`, payload)).data;
			} catch (error) {
				throw toApiError(error, 'Erro ao fazer upgrade do plano');
			}
		},
	});
